import request from '@/utils/request'

// 认证
export const login = data => request.post('/auth/login', data)
export const sendLoginSmsCode = data => request.post('/auth/sms-code', data)
export const sendChangePasswordSms = () => request.post('/auth/change-password/send-sms')
export const changePasswordBySms = data => request.post('/auth/change-password', data)

// 数据看板
export const getDashboard = (params) => request.get('/dashboard', { params })

// 用户管理
export const getUsers = params => request.get('/users', { params })
export const addUser = data => request.post('/users', data)
export const updateUser = (id, data) => request.put(`/users/${id}`, data)
export const resetPassword = (id, data) => request.put(`/users/${id}/reset-password`, data)
export const getUserPermissions = id => request.get(`/users/${id}/permissions`)
export const assignUserPermissions = (id, permissionIds) => request.put(`/users/${id}/permissions`, { permissionIds })
export const getAllUsers = () => request.get('/users/all')
export const userRefreshCache = () => request.post('/users/refreshCache')
export const userRefreshSalesmenCache = () => request.post('/users/refreshSalesmenCache')
export const userRefreshStockUserCache = () => request.post('/users/refreshStockUserCache')
export const getStockUserAll = () => request.get('/users/stockUserAll')
export const updateUserStatus = data => request.put('/users/updateUserStatus', data)


// 角色管理
export const getRoles = params => request.get('/roles', { params })
export const getAllRoles = () => request.get('/roles/all')
export const addRole = data => request.post('/roles', data)
export const updateRole = (id, data) => request.put(`/roles/${id}`, data)
export const deleteRole = id => request.delete(`/roles/${id}`)
export const getRolePermissions = id => request.get(`/roles/${id}/permissions`)
export const assignRolePermissions = (id, permissionIds) => request.put(`/roles/${id}/permissions`, { permissionIds })
export const rolesRefreshCache = () => request.post('/roles/refreshCache')

// 权限管理
export const getPermissionsGrouped = () => request.get('/permissions/grouped')
export const getPermissionMenuList = () => request.get('/permissions/menuList')
export const addPermission = data => request.post('/permissions/add',data)
export const updatePermission = data => request.put('/permissions/update',data)
export const deletePermission = id => request.delete(`/permissions/delete/${id}`)
export const getMenuUnreadCount = () => request.get('/permissions/getMenuUnreadCount')


// 商品管理
export const getProducts = data => request.post('/productSpu', data)
export const getStatusSummary = data => request.post('/productSpu/getStatusSummary', data)
export const publishProductWithSkus = data => request.post('/productSpu/with-skus', data)
export const getSpuDetails = params => request.get(`/productSpu/getDetails`,{ params })
export const updateProductWithSkus = (id, data) => request.put(`/productSpu/${id}/with-skus`, data)
export const confirmBatchLaunch = data => request.put(`/productSpu/confirmBatchLaunch`, data)
export const confirmBatchDelisted = data => request.put(`/productSpu/confirmBatchDelisted`, data)
export const getProductSkus = productId => request.get(`/productSpu/${productId}/skus`)
export const publishProduct = id => request.put(`/productSpu/${id}/publish`)
export const deleteProduct = id => request.delete(`/productSpu/${id}`)
export const getDistributorBySpuId = id => request.get(`/productSku/getDistributorBySpuId/${id}`)
export const productSpuUpdateRemark = (data) => request.put(`/productSpu/updateRemark`, data)
export const addProductSalutationQueue = (data) => request.post(`/productSpu/addSalutationQueue`, data)
export const spuRecordRead = (data) => request.put(`/productSpu/spuRecordRead`, data)
export const spuUpdateImages = (data) => request.put(`/productSpu/updateImages`, data)
export const batchUpdateLabels = data => request.put('/productSpu/batchUpdateLabels', data)

// sku相关
export const searchSkuList = params => request.get('/productSku/getSkuCodeList', { params })
export const searchSkuAndStockList = params => request.get('/productSku/getSkuCodeAndStockListV2', { params })
export const getSkcSkus = params => request.get('/productSku/getSkcSkus', { params })
export const getSkcSkusAndStock = params => request.get('/productSku/getSkcSkusAndStock', { params })

// 商品分类
export const getCategoryTree = () => request.get('/categories/tree')
export const getCategoryCacheTree = () => request.get('/categories/cacheTree')
export const createCategory = data => request.post('/categories', data)
export const updateCategory = (id, data) => request.put(`/categories/${id}`, data)
export const deleteCategory = id => request.delete(`/categories/${id}`)
export const categoryRefreshCache = id => request.post(`/categories/refreshCache`)


// 商品规格基础选项（颜色/尺码）
export const getProductSpecOptions = params => request.get('/product-spec-options', { params })
export const getProductSpecOptionCaches = params => request.get('/product-spec-options/cacheList', { params })
export const addProductSpecOption = data => request.post('/product-spec-options', data)
export const updateProductSpecOption = (id, data) => request.put(`/product-spec-options/${id}`, data)
export const deleteProductSpecOption = id => request.delete(`/product-spec-options/${id}`)
export const productSpecOptionRefreshCache = params => request.post('/product-spec-options/refreshCache', { params })


// 文件上传
export const uploadImage = data => request.post('/tos/upload/image', data)
export const uploadPdf = data => request.post('/tos/upload/pdf', data)
export const uploadFile = data => request.post('/tos/upload/file', data)

// 物流公司（快递公司）管理
export const getExpressCompanies = params => request.get('/express-companies', { params })
export const getAllExpressCompanies = () => request.get('/express-companies/all')
export const addExpressCompany = data => request.post('/express-companies', data)
export const updateExpressCompany = (id, data) => request.put(`/express-companies/${id}`, data)
export const deleteExpressCompany = id => request.delete(`/express-companies/${id}`)
export const expressCompanyRefreshCache = id => request.post(`/express-companies/refreshCache`)


// 仓库管理
export const getWarehouses = params => request.get('/warehouses', { params })
export const getAllWarehouses = () => request.get('/warehouses/all')
export const warehousesRefreshCache = () => request.post('/warehouses/refreshCache')
export const addWarehouse = data => request.post('/warehouses', data)
export const updateWarehouse = (id, data) => request.put(`/warehouses/${id}`, data)
export const deleteWarehouse = id => request.delete(`/warehouses/${id}`)
export const getSkuStockWarehouse = params => request.get(`/warehouses/getSkuStockWarehouse`,{ params })


// 省份
export const getAllProvinces = () => request.get('/provinces/all')
export const getProvinces = () => request.get('/provinces')
export const addProvince = data => request.post('/provinces', data)
export const updateProvince = (id, data) => request.put(`/provinces/${id}`, data)
export const deleteProvince = id => request.delete(`/provinces/${id}`)

// 订单管理
export const getOrders = params => request.get('/orders', { params })
export const getOrderStatusSummary = params => request.get('/orders/getStatusSummary', { params })
export const addOrder = data => request.post('/orders', data)
export const updateOrder = (id, data) => request.put(`/orders/${id}`, data)
export const getOrderById = id => request.get(`/orders/${id}`)
export const updateOrderStatus = data => request.post('/orders/updateOrderStatus', data)
export const updateOrderStatusIssue = data => request.post('/orders/updateOrderStatusIssue', data)
export const updateException = data => request.put('/orders/updateException', data)
export const notUpdateLabel = data => request.put('/orders/notUpdateLabel', data)
export const updateLogisticsInfo = data => request.put('/orders/updateLogisticsInfo', data)
export const getOrderTracking = id => request.get(`/orders/${id}/tracking`)
export const shipOrder = (id, data) => request.put(`/orders/${id}/ship`, data)
export const cancelOrder = (id, data) => request.put(`/orders/${id}/cancel`, data)
export const batchOrderSetStatus = data => request.put('/orders/status/batch', data)
export const updateShippingCost = data => request.put('/orders/updateShippingCost', data)
export const updateOrderException = data => request.post('/orders/updateExcInfo', data)
export const getExceptionOrderCount = () => request.get('/orders/getExceptionOrderCount')
export const getOrderDataSummary = params => request.get('/orders/getDataSummary', { params })
export const orderDataSummaryClose = () => request.get('/orders/dataSummaryClose')
export const orderExchangeResend = data => request.post('/orders/exchangeResend',data)
export const orderUploadAeWaybill = data => request.put('/orders/uploadAeWaybill',data)



// 日志
export const getBusinessLogs = params => request.get('/businessOperationLog', { params })

// 通知（需用户确认）
export const getSysNoticeList1 = params => request.get('/sysNotice/list1', { params })
export const getSysNoticeList2 = () => request.get('/sysNotice/list2')
export const addNotice = data => request.post('/sysNotice/addNotice', data)
export const ackPriceChangeNotices = data => request.post('/sysNotice/ackPriceChangeNotices', data)
export const getTotalUnreadCount = () => request.get('/sysNotice/getTotalUnreadCount')
export const getSysNoticeList = params => request.get('/sysNotice/list', { params })

// 分销商管理
export const getDistributors = params => request.get('/distributors', { params })
export const getAllDistributors = () => request.get('/distributors/all')
export const addDistributor = data => request.post('/distributors', data)
export const updateDistributor = (id, data) => request.put(`/distributors/${id}`, data)
export const deleteDistributor = id => request.delete(`/distributors/${id}`)
export const distributorWalletRecharge = (data) => request.put(`/distributorWallet/recharge`, data)
export const getSalesmen = () => request.get('/users/salesmen')
export const freezeDistributor = (id, data) => request.put(`/distributors/${id}/freeze`, data)
export const unfreezeDistributor = (id, data) => request.put(`/distributors/${id}/unfreeze`, data)
export const getDistributorFreezeLogs = (id, params) => request.get(`/distributors/${id}/freeze-logs`, { params })
export const distributorRefreshCache = () => request.post('/distributors/refreshCache')
export const getDistributorData = (id) => request.get(`/distributors/getDistributorData/${id}`)
export const distributorRechargeRebate = (data) => request.put(`/distributors/rechargeRebate`, data)
export const batchUpdateDistributorLabel = (data) => request.put(`/distributors/batchUpdateDistributorLabel`, data)


// 个人主页
export const getUserInfo = (id) => request.get(`/users/${id}`)
export const transferToCredit = (data) => request.put(`/distributorWallet/transferToCredit`, data)

// 分销子账号管理
export const getSubAccounts = params => request.get('/distributor/sub-accounts', { params })
export const addSubAccount = data => request.post('/distributor/sub-accounts', data)
export const updateSubAccountStatus = (id, data) => request.put(`/distributor/sub-accounts/${id}/updateStatus`, data)
export const getSubAccountsCacheList = params => request.get('/distributor/sub-accounts/cacheList', { params })

// 分销商申请/审核
export const applyDistributor = data => request.post('/distributor-applies', data)
export const getDistributorApplies = params => request.get('/distributor-applies', { params })
export const approveDistributorApply = (id, data) => request.put(`/distributor-applies/${id}/approve`, data)
export const rejectDistributorApply = (id, data) => request.put(`/distributor-applies/${id}/reject`, data)

//分销商钱包资金流水
export const getDistributorWalletLogs = params => request.get('/distributorWalletLogs', { params })


// 分销商钱包/提现
export const getDistributorWallet = id => request.get(`/distributorWallet/${id}/wallet`)

// AI扣费字典（可配置扣费单价）
export const getAiFeeDictionary = () => request.get('/ai-fee-dictionary')
export const addAiFeeDictionary = data => request.post('/ai-fee-dictionary', data)
export const updateAiFeeDictionary = (id, data) => request.put(`/ai-fee-dictionary/${id}`, data)
export const deleteAiFeeDictionary = id => request.delete(`/ai-fee-dictionary/${id}`)


// 分销商提现记记录
export const getWithdraws = params => request.get('/distributorWithdraws', { params })
export const applyWithdraw = data => request.post('/distributorWithdraws', data)
export const approveWithdraw = id => request.put(`/distributorWithdraws/${id}/approve`)
export const transferWithdraw = (data) => request.put(`/distributorWithdraws/transfer`,data)
export const rejectWithdraw = (data) => request.put(`/distributorWithdraws/reject`, data)

// 账单
export const getBill = params => request.get('/bill', { params })
export const repaymentBill = data => request.put('/bill/transferToCredit', data)
export const confirmBill = data => request.put('/bill/confirm', data)
export const getBillSummary = params => request.get(`/bill/getBillSummary`, { params })


// 渠道商务钱包/充值/提现/流水
export const getSalesmanWalletData = () => request.get('/salesman-wallet/getSalesmanWalletData')
export const getSalesmanWallet = (userId) => request.get('/salesman-wallet', { params: userId ? { userId } : {} })
export const getSalesmanWalletLogs = params => request.get('/salesman-wallet-logs', { params })
export const getSalesmanRecharges = params => request.get('/salesman-recharges', { params })
export const approveSalesmanRecharge = id => request.put(`/salesman-recharges/${id}/approve`)
export const rejectSalesmanRecharge = (id, data) => request.put(`/salesman-recharges/${id}/reject`, data)
export const rebateToRecharge = (data) => request.put(`/salesman-wallet/rebateToRecharge`, data)

// 供应商务钱包/充值/提现/流水
export const getSupplierWalletData = () => request.get('/supplierWallet/getSupplierWalletData')
export const getSupplierWalletLogs = params => request.get('/supplierWalletLogs', { params })


// 渠道商务提现记录
export const getSalesmanWithdraws = params => request.get('/salesmanWithdraws', { params })
export const applySalesmanWithdraw = data => request.post('/salesmanWithdraws', data)
export const approveSalesmanWithdraw = id => request.put(`/salesmanWithdraws/${id}/approve`)
export const transferSalesmanWithdraw = (data) => request.put(`/salesmanWithdraws/transfer`,data)
export const rejectSalesmanWithdraw = (data) => request.put(`/salesmanWithdraws/reject`, data)

// 供应商提现记录
export const getSupplierWithdraws = params => request.get('/supplierWithdraws', { params })
export const applySupplierWithdraw = data => request.post('/supplierWithdraws', data)
export const approveSupplierWithdraw = id => request.put(`/supplierWithdraws/${id}/approve`)
export const transferSupplierWithdraw = (data) => request.put(`/supplierWithdraws/transfer`,data)
export const rejectSupplierWithdraw = (data) => request.put(`/supplierWithdraws/reject`, data)

// 等级管理
export const getDistributorLevels = () => request.get('/rebate-levels')
export const getDistributorLevelCaches = () => request.get('/rebate-levels/cacheList')
export const addDistributorLevel = data => request.post('/rebate-levels', data)
export const updateDistributorLevel = (id, data) => request.put(`/rebate-levels/${id}`, data)
export const rebateLevelsRefreshCache = () => request.post('/rebate-levels/refreshCache')


// 锁仓/虚拟库存
export const getLockConfigsByLevel = level => request.get('/lock-levels', { params: { level } })
export const replaceLockConfigsByLevel = (level, list) => request.put('/lock-levels/replace', list || [], { params: { level } })

// 生产备货
export const getProductionOrders = params => request.get('/productionOrders', { params })
export const getProductionOrderStatusSummary = params => request.get('/productionOrders/getStatusSummary', { params })
export const addProductionOrder = data => request.post('/productionOrders/add', data)
export const reviewProductionOrder = data => request.put('/productionOrders/review', data)
export const confirmSupplierProductionOrder = data => request.put('/productionOrders/confirmSupplier', data)
export const getGroupBuyRecords = params => request.get('/productionOrders/getGroupBuyRecords', { params })
export const getUserGroupBuyRecord = params => request.get('/productionOrders/getUserGroupBuyRecord', { params })
export const submitGroupBuy = data => request.post('/productionOrders/submitGroupBuy', data)
export const cancelProductionOrder = data => request.put('/productionOrders/cancel', data)
export const updateProductionPrice = data => request.put('/productionOrders/updateProductionPrice', data)
export const returnProductionOrder = data => request.post('/productionOrders/returned', data)
export const productionOrderMandatoryCompletion = data => request.put('/productionOrders/mandatoryCompletion', data)
export const viewRecordProductionOrder = data => request.put('/productionOrders/viewRecord', data)
export const getProductionOrderSummary = params => request.get(`/productionOrders/getSummary`, { params })


// 入库单
export const getInboundOrders = params => request.get('/inboundOrder', { params })
export const getInboundOrderStatusSummary = params => request.get('/inboundOrder/getStatusSummary', { params })
export const getQualityInquiry = params => request.get('/inboundOrder/qualityInquiry', { params })
export const saveQualityData = data => request.put('/inboundOrder/quality', data)
export const inboundOrderMandatoryCompletion = data => request.put('/inboundOrder/mandatoryCompletion', data)



// 渠道商务等级
export const getSalesmanLevels = () => request.get('/salesman-rebate-levels')
export const getSalesmanLevelCaches = () => request.get('/salesman-rebate-levels/cacheList')
export const addSalesmanLevel = data => request.post('/salesman-rebate-levels', data)
export const updateSalesmanLevel = (id, data) => request.put(`/salesman-rebate-levels/${id}`, data)
export const salesmanRebateLevelRefreshCache = () => request.post(`/salesman-rebate-levels/refreshCache`)


// 分销商充值
export const getRecharges = params => request.get('/recharges', { params })
export const applyRecharge = data => request.post('/recharges', data)
export const approveRecharge = id => request.put(`/recharges/${id}/approve`)
export const rejectRecharge = (id, data) => request.put(`/recharges/${id}/reject`, data)

// 供应商管理
export const getSuppliers = params => request.get('/suppliers', { params })
export const addSupplier = data => request.post('/suppliers', data)
export const updateSupplier = (id, data) => request.put(`/suppliers/${id}`, data)
export const deleteSupplier = id => request.delete(`/suppliers/${id}`)
export const getSupplierWallet = id => request.get(`/suppliers/${id}/wallet`)
export const supplierRefreshCache = data => request.post('/suppliers/refreshCache', data)
export const getSupplierAll = () => request.get('/suppliers/all')

// sku管理
export const getInventory = params => request.get('/productSkuStock', { params })
export const getInventoryBySkuCode = params => request.get('/productSkuStock/by-sku-code', { params })
export const addInventory = data => request.post('/productSkuStock', data)
export const updateInventory = (id, data) => request.put(`/productSkuStock/${id}`, data)

// sku管理
export const getWmsInventory = params => request.get('/wmsInventoryStock', { params })
export const addWmsInventory = data => request.post('/wmsInventoryStock', data)
export const updateWmsInventory = (id, data) => request.put(`/wmsInventoryStock/${id}`, data)
export const getWmsInventorySummary = params => request.get(`/wmsInventoryStock/getWmsInventorySummary`, { params })


// 库存管理
export const getUserInventoryDetailList = params => request.get('/inventoryUserStock/userInventoryDetail/list', { params })
export const getUserInventory = params => request.get('/inventoryUserStock', { params })
export const addUserInventory = data => request.post('/inventoryUserStock', data)
export const updateUserInventory = (id, data) => request.put(`/inventoryUserStock/${id}`, data)
export const getStockDetail = params => request.get('/inventoryUserStock/getStockDetail', { params })
export const getUserInventorySummary = params => request.get(`/inventoryUserStock/getUserInventorySummary`, { params })
export const getMergeSummary = params => request.get(`/inventoryUserStock/getMergeSummary`, { params })
export const getOverseasInTransitDetail = params => request.get('/inventoryUserStock/getOverseasInTransitDetail', { params })


// 库存变动记录
export const getInventoryLogs = params => request.get('/inventoryChangeLog/logs', { params })

// WMS库存变动记录
export const getWmsInventoryLogs = params => request.get('/wmsInventoryChangeLog/logs', { params })

// 锁库配置
export const getLockUpConfigList = () => request.get('/lockUpConfig/list')
export const batchSaveLockUpConfig = data => request.post('/lockUpConfig/batchSave', data)

// 锁仓记录
export const lockUpList = params => request.get('/lockUpRecord/list', { params })
export const submitLockUp = data => request.post('/lockUpRecord/submit', data)

// 系统配置
export const getSysConfig = params => request.get('/sysConfig/getConfigByType', { params })
export const saveSysConfig = (data) => request.post('/sysConfig/saveSysConfig', data)
export const saveSysConfigList = (data) => request.post('/sysConfig/saveSysConfigList', data)
export const getConfigByTypeCache = params => request.get('/sysConfig/getConfigByTypeCache', { params })
export const sysConfigRefreshCache = params => request.get('/sysConfig/refreshCache', { params })

// 标签管理
export const getProductLabelList = params => request.get('/productLabel', { params })
export const addProductLabel = data => request.post('/productLabel', data)
export const updateProductLabel = data => request.put('/productLabel', data)
export const productLabelRefreshCache = () => request.post('/productLabel/refreshCache')
export const getProductLabelAll = () => request.get('/productLabel/all')

// skc相关
export const getSkcListBySkc = params => request.get('/productSkc/getSkcListBySkc', { params })

// 库位管理
export const getStockLocationList = params => request.get('/stockLocationManage', { params })
export const getStockLocationAll = () => request.get('/stockLocationManage/all')
export const addStockLocation = data => request.post('/stockLocationManage', data)
export const updateStockLocation = (id, data) => request.put(`/stockLocationManage/${id}`, data)
export const stockLocationRefreshCache = () => request.post('/stockLocationManage/refreshCache')

// 公司收款方式
export const getPaymentConfigList = params => request.get('/paymentConfig/list', { params })
export const addPaymentConfig = data => request.post('/paymentConfig/add', data)
export const updatePaymentConfig = data => request.post('/paymentConfig/update', data)
export const deletePaymentConfig = (id) => request.delete(`/paymentConfig/delete/${id}`)

// 用户账户管理
export const getUserAccountList = () => request.get(`/userAccount/listByUserId`)
export const addUserAccount = data => request.post('/userAccount/add', data)
export const updateUserAccount = data => request.post('/userAccount/update', data)
export const deleteUserAccount = (id) => request.delete(`/userAccount/delete/${id}`)

// 充值申请
export const getRechargeRecordList = params => request.get('/rechargeRecord', { params })
export const addRechargeRecord = data => request.post('/rechargeRecord/apply', data)
export const rejectRechargeRecord = (data) => request.put(`/rechargeRecord/reject`, data)
export const approveRechargeRecord = (id) => request.put(`/rechargeRecord/approve/${id}`)

// 仓库分组
export const getAllWarehousesGroup = () => request.get('/warehouseGroup/all')
export const warehousesGroupRefreshCache = () => request.post('/warehouseGroup/refreshCache')
export const getWarehousesGroup = params => request.get('/warehouseGroup', { params })
export const addWarehouseGroup = data => request.post('/warehouseGroup', data)
export const updateWarehouseGroup = (id, data) => request.put(`/warehouseGroup/${id}`, data)
export const getWarehouseGroupCarrier = (id) => request.get(`/warehouseGroup/getWarehouseCarrier/${id}`)
export const saveWarehouseGroupCarriers = (id,data) => request.put(`/warehouseGroup/saveWarehouseGroupCarriers/${id}`,data)

// 出库单
export const getOutboundOrders = params => request.get('/outboundOrder', { params })
export const getOutboundOrderStatusSummary = params => request.get('/outboundOrder/getStatusSummary', { params })
export const getOutboundOrderDetailsById = (id) => request.get(`/outboundOrder/getDetailsById/${id}`)
export const rePickOrder = (id) => request.put(`/outboundOrder/pickAgain/${id}`)
export const reportShortage = (id) => request.put(`/outboundOrder/reportShortage/${id}`)
export const printLabel = params => request.get(`/outboundOrder/printLabel`,{params})
export const printAeLabel = params => request.get(`/outboundOrder/printAeLabel`,{params})
export const completeDirectlyOrder = (id) => request.put(`/outboundOrder/completeDirectly/${id}`)
export const directShipOrder = (id) => request.put(`/outboundOrder/directShip/${id}`)


// TEMU商品基础信息
export const getTemuProductSpecOptions = params => request.get('/temuProductSpecOption', { params })
export const addTemuProductSpecOption = data => request.post('/temuProductSpecOption', data)
export const updateTemuProductSpecOption = (id, data) => request.put(`/temuProductSpecOption/${id}`, data)
export const deleteTemuProductSpecOption = id => request.delete(`/temuProductSpecOption/${id}`)
export const getTemuProductSpecOptionCaches = params => request.get('/temuProductSpecOption/cacheList', { params })
export const productTemuSpecOptionRefreshCache = params => request.post('/temuProductSpecOption/refreshCache', { params })

// 数据看板
export const getTotalData = params => request.get('/dataOverview/getTotalData', { params })
export const getDataGetDistributorRank = params => request.get('/dataOverview/getDataGetDistributorRank', { params })
export const getDistributorChart = params => request.get('/dataOverview/getDistributorChart', { params })
export const getRankChart = params => request.get('/dataOverview/getRankChart', { params })
export const getSalesChart = params => request.get('/dataOverview/getSalesChart', { params })
export const getMockFinance = params => request.get('/dataOverview/getMockFinance', { params })
export const getStockChart = params => request.get('/dataOverview/getStockChart', { params })
export const getFulfill = params => request.get('/dataOverview/getFulfill', { params })
export const getProductChart = params => request.get('/dataOverview/getProductChart', { params })
export const getWarehouseRank = params => request.get('/dataOverview/getWarehouseRank', { params })
export const getProvinceRank = params => request.get('/dataOverview/getProvinceRank', { params })

// 渠道商务
export const getSalesman = params => request.get('/users/salesmenPage', { params })

// 备货出库
export const getOutboundStockingOrders = params => request.get('/outboundStockingOrder', { params })
export const getOutboundStockingOrderStatusSummary = params => request.get('/outboundStockingOrder/getStatusSummary', { params })
export const createProductionOrder = data => request.post('/outboundStockingOrder/createProductionOrder', data)
export const reviewOutboundStockingOrder = data => request.put('/outboundStockingOrder/review', data)
export const endGroupBuyOutboundStockingOrder = data => request.put('/outboundStockingOrder/endGroupBuy', data)
export const getOutboundStockingGroupBuyRecords = params => request.get('/outboundStockingOrder/getGroupBuyRecords', { params })
export const getUserOutboundStockingGroupBuyRecord = params => request.get('/outboundStockingOrder/getUserGroupBuyRecord', { params })
export const submitOutboundStockingGroupBuy = data => request.post('/outboundStockingOrder/submitGroupBuy', data)
export const issueOutboundStockingOrder = data => request.put('/outboundStockingOrder/issue', data)
export const getAdditionalOrderRecords = params => request.get('/outboundStockingOrder/getAddOderRecords', { params })
export const submitAdditionalOrder = data => request.post('/outboundStockingOrder/submitAdditionalOrder', data)
export const cancelOutboundStockingOrder = data => request.put('/outboundStockingOrder/cancel', data)
export const overseasInboundSubmit = data => request.post('/outboundStockingOrder/overseasInboundSubmit', data)
export const completionOutboundStockingOrder = data => request.post('/outboundStockingOrder/completion', data)
export const viewOutboundStockingOrder = data => request.put('/outboundStockingOrder/viewRecord', data)

// 店铺管理
export const getShopList = params => request.get('/shopManage', { params })
export const addShop = data => request.post('/shopManage', data)
export const updateShop = data => request.put('/shopManage', data)
export const createToken = data => request.post('/shopManage/createToken', data)
export const getAllShop = () => request.get('/shopManage/all')
export const shopRefreshCache = () => request.post('/shopManage/refreshCache')
export const updateShopSubUserId = data => request.post('/shopManage/updateShopSubUserId' ,data)


// TEMU商品分类
export const getTemuCategoryTree = () => request.get('/temuProductCategory/tree')
export const getTemuCategoryCacheTree = () => request.get('/temuProductCategory/cacheTree')
export const createTemuCategory = data => request.post('/temuProductCategory', data)
export const updateTemuCategory = (id, data) => request.put(`/temuProductCategory/${id}`, data)
export const deleteTemuCategory = id => request.delete(`/temuProductCategory/${id}`)
export const temuCategoryRefreshCache = id => request.post(`/temuProductCategory/refreshCache`)
export const getTemuCacheTree = () => request.get(`/temuProductCategory/getCacheTree`)

// 自动上款记录
export const getSalutationQueueList = params => request.get('/productSalutationQueue', { params })
export const getSalutationQueueStatusSummary = params => request.get('/productSalutationQueue/getStatusSummary', { params })
export const getSalutationQueueToken = () => request.get('/productSalutationQueue/getSalutationQueueToken')
export const resubmitSalutationQueue = (data) => request.put('/productSalutationQueue/resubmission',data)
export const deleteSalutationQueue = (data) => request.put('/productSalutationQueue/delete',data)

// TEMU平台单
export const getTemuOrderList = params => request.get('/tmeuOrder', { params })
export const getTemuOrderStatusSummary = params => request.get('/tmeuOrder/getStatusSummary', { params })
export const orderOnlineGetWarehouseList = (data) => request.post('/tmeuOrder/orderOnline-getWarehouseList', data)
export const orderOnlineGetQuote = (data) => request.post('/tmeuOrder/orderOnline-getQuote', data)
export const orderOnlineSubmit = (data) => request.post(`/tmeuOrder/orderOnline`,data)
export const splitTemuOrder = (data) => request.post(`/tmeuOrder/splitItem`,data)
export const orderOnlineGetSkuStock = params => request.get(`/tmeuOrder/orderOnline-getSkuStock`,{ params })
export const updateTemuOrderSku = ( data ) => request.put(`/tmeuOrder/updateTemuOrderSku`,data)



// ai生成商品
export const getAiProductList = params => request.get('/aiProductData', { params })
export const updateAiProduct = (data) => request.post('/aiProductData/updateAiProduct', data)

// 采购备货
export const getPurchaseOrders = params => request.get('/purchaseOrder', { params })
export const getPurchaseOrderStatusSummary = params => request.get('/purchaseOrder/getStatusSummary', { params })
export const purchaseOrderEntryTrackingNumber = (data) => request.put('/purchaseOrder/entryTrackingNumber', data)
export const purchaseOrderConfirmReceipt = (data) => request.put('/purchaseOrder/confirmReceipt', data)
export const purchaseOrderPrintLabel = params => request.get(`/purchaseOrder/printLabel`,{params})
export const purchaseOrderConfirmLabeling = (data) => request.put('/purchaseOrder/confirmLabeling', data)
export const purchaseOrderShipment = (data) => request.put('/purchaseOrder/shipment', data)
export const getPurchaseOrderTracking = id => request.get(`/purchaseOrder/${id}/tracking`)
export const purchaseOrderConfirmPurchase = (data) => request.put(`/purchaseOrder/confirmPurchase`,data)
export const purchaseOrderTransferWmsOut = (data) => request.put(`/purchaseOrder/transferWmsOut`,data)
export const purchaseOrderBatchCancelOrder = (data) => request.put(`/purchaseOrder/batchCancelOrder`,data)
export const purchaseOrderBatchUpdateRemark = (data) => request.put(`/purchaseOrder/batchUpdateRemark`,data)
export const updatePurchaseOrderThreeOrderSn = (data) => request.put(`/purchaseOrder/updateThreeOrderSn`,data)


// 商品反馈
export const getProductFeedbackList = params => request.get('/productFeedback', { params })
export const addProductFeedback = data => request.post('/productFeedback/addFeedback', data)
export const confirmProductFeedback = data => request.put('/productFeedback/confirmProcessing', data)

// 换单重发单
export const getExchangeResendList = params => request.get('/exchangeResendOrder', { params })
export const getExchangeResendStatusSummary = params => request.get('/exchangeResendOrder/getStatusSummary', { params })

// 备货报表
export const getProductSkcReportList = params => request.get('/productSkcReport', { params })
export const getProductSkcReportDataSummary = params => request.get('/productSkcReport/getDataSummary', { params })
export const getProductSkcReportSalesDistribution = params => request.get('/productSkcReport/salesDistribution', { params })
export const getThresholdDays = () => request.get('/productSkcReport/getThresholdDays')
export const setThresholdDays = (params) => request.get('/productSkcReport/setThresholdDays', {params})

